import { AfterViewInit, Component, Inject, Input, EventEmitter, Output } from '@angular/core';

import { Observable, Subject, Subscription, combineLatest } from 'rxjs';

import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';

import { UserService } from '../../../humain/user/services/user.service';
import { UserTLR } from '../../../humain/user/entities/user-tlr.entity';

import { AntenneService } from '../services/antenne.service';
import { AntenneTLR } from '../entities/antenne-tlr.entity';

@Component({
	selector: 'cc-antenne-selector',
	templateUrl: 'antenne-selector.html',
	styleUrls: ['antenne-selector.css']
})
export class ChargeConduiteAntenneSelectorComponent implements AfterViewInit {
	// Liste des antennes autorisees
	antennes!: AntenneTLR[];
	
	// Evenements pour les chargements de la liste d'antennes
	private antennesLoaded = new Subject<void>();

	// Antenne actuellement selectionnee dans le composant HTML
	_selectedAntenneId!: number | null;

	constructor( //
		@Inject(UserService) private userService: UserService, //
		@Inject(AntenneService) private antenneService: AntenneService //
	) {
		let user$ = this.userService.getCurrentUserTLR();
		
		// Definir la valeur a afficher par defaut comme etant la combinaison de la volonte du parent et de l'etat de l'utilisateur
		// (NB: on ajoute l'evenement de chargement des antennes pour etre sur qu'on ne tente pas de fixer une valeur avant qu'elle soit présente dans la liste)
		combineLatest([this.resetCommandsSubject, user$, this.antennesLoaded]).subscribe(
			(entries: [number | null | undefined, UserTLR, void]) => {
				let defaultFromParent = entries[0];
				let user = entries[1];
				let defaultValue = defaultFromParent != undefined ? defaultFromParent : user.antenneId;
				if (this._selectedAntenneId !== defaultValue) {
					this._selectedAntenneId = defaultValue;
					this.notifyChange();
				}
			}
		);

		// Charger l'ensemble des antennes
		this.userService.getAntennesOnWhichUserIsCC().subscribe(
			(antennes: AntenneTLR[]) => {
				this.antennes = antennes;
				this.antennesLoaded.next();
			}
		);
		
		// Toujours au moins assurer qu'il y a une initialisation du composant lancee, que le parent en demande une ou pas
		this.resetCommandsSubject.next(undefined);
	}

	// Id du champ
	@Input() id!: string;

	// Mode du champ
	@Input() disabled = false;

	// Parametres de style
	public _mandatory: boolean = false;
	@Input() set mandatory(value: boolean | undefined) {
		if (value) {
			this._mandatory = value;
		}
	}
	get mandatory(): boolean | undefined {
		return this._mandatory;
	}
	public _labelClass = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	public _fieldClass = 'col-md-3';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}

	// Label pour l'option wildcard (dont la valeur vaut 'null'). L'absence de label (undefined ou null) signifie que cette option n'est pas autorisee
	@Input() wildcardOptionLabel: string | undefined | null = 'Tous';
	
	// Observable pour les commandes de reinitialisation du composant
	private resetCommandsSubject = new SubjectRelay<number | null | undefined>();
	@Input() set resetCommands(obs: Observable<number | null | undefined> | null | undefined) {
		this.resetCommandsSubject.registerSource(obs);
	} 

	// Evenement de sortie pour le changement de l'antenne id selectionnee
	@Output() selectedAntenneIdChange = new EventEmitter<number | null>();

	// One-way out binding pour la selection actuelle en format complet
	@Output() selectedAntenneChange = new EventEmitter<AntenneTLR | null>();
	
	ngAfterViewInit() {
	}

	onSelectionChange() {
		this.notifyChange();
	}

	onCancelSelection() {
		if (!this.disabled) {
			this._selectedAntenneId = null;
			this.notifyChange();
		}
	}

	private notifyChange() {
		const id = this._selectedAntenneId;
		this.selectedAntenneIdChange.emit(id);
		if (id) {
			this.antenneService.getAntenneTLRById(id).subscribe(
				(antenne: AntenneTLR | undefined) => {
					if (antenne) {
						this.selectedAntenneChange.emit(antenne);
					} else {
						throw new Error("Server doesn't recognize this antenne id anymore: " + id);
					}
				}
			);
		} else {
			this.selectedAntenneChange.emit(null);
		}
	}
}